import { useEffect, useMemo, useState } from "react";
import { Button, Col } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faListCheck,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";

export default function AspekKegiatanPage({
  selectedMatpel,
  selectedKegiatan,
  onBack,
  getToken,
  getUserId,
  ToastSuccess,
  ToastError,
}) {
  const [aspekData, setAspekData] = useState([]);
  const [searchAspek, setSearchAspek] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [editAspekId, setEditAspekId] = useState(null);

  const [formAspek, setFormAspek] = useState({
    name_sub_activities: "",
  });

  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deletingAspekId, setDeletingAspekId] = useState(null);

  const cleanStorageValue = (value) => {
    return (value || "")
      .toString()
      .replace(/[|&;$%@"<>()+,]/g, "");
  };

  const resolveToken = () => {
    if (typeof getToken === "function") {
      try {
        return getToken() || "";
      } catch (error) {
        return localStorage.getItem("token") || "";
      }
    }

    return localStorage.getItem("token") || "";
  };

  const resolveUserId = () => {
    let userId = "";

    if (typeof getUserId === "function") {
      try {
        userId = getUserId() || "";
      } catch (error) {
        userId = "";
      }
    }

    return cleanStorageValue(
      userId ||
        localStorage.getItem("id_admin") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("id_user") ||
        localStorage.getItem("userId") ||
        ""
    );
  };

  const showSuccess = (title) => {
    if (
      ToastSuccess &&
      typeof ToastSuccess.fire === "function"
    ) {
      ToastSuccess.fire({
        icon: "success",
        title: title || "Data berhasil disimpan",
      });

      return;
    }

    Swal.fire({
      icon: "success",
      title: title || "Data berhasil disimpan",
      showConfirmButton: false,
      timer: 1600,
    });
  };

  const showError = (title) => {
    if (
      ToastError &&
      typeof ToastError.fire === "function"
    ) {
      ToastError.fire({
        icon: "error",
        title: title || "Terjadi kesalahan",
      });

      return;
    }

    Swal.fire({
      icon: "error",
      title: title || "Terjadi kesalahan",
      confirmButtonText: "Tutup",
    });
  };

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data?.rows)) {
      return responseData.data.rows;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result?.data)) {
      return responseData.result.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const normalizeAspek = (item) => {
    return {
      id:
        item?.id ||
        item?.ysb_sub_activity_id ||
        item?.sub_activity_id ||
        "",

      ysb_type_activities_id:
        item?.ysb_type_activities_id ||
        item?.ysb_type_activity_id ||
        item?.type_activity_id ||
        "",

      name_sub_activities:
        item?.name_sub_activities ||
        item?.name_sub_activity ||
        item?.nama_aspek ||
        item?.name_aspek ||
        "",

      create_by: item?.create_by || "",
      update_by: item?.update_by || "",
      created_at: item?.created_at || "",
      updated_at: item?.updated_at || "",
      raw: item,
    };
  };

  const resetForm = () => {
    setEditAspekId(null);

    setFormAspek({
      name_sub_activities: "",
    });
  };

  const getAspekData = async () => {
    const kegiatanId = selectedKegiatan?.id || "";

    if (!kegiatanId) {
      setAspekData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const token = resolveToken();

      /*
       * ID kegiatan dikirim ke API.
       * Setelah respons diterima, data tetap difilter
       * kembali di frontend agar benar-benar hanya
       * menampilkan aspek dari kegiatan yang dipilih.
       */
      const requestBody = {
        page: 1,
        limit: 1000,
        // Data yang pertama kali dibuat ditampilkan paling atas.
        ascending: true,
        search: "",
        branch: "",
        level:
          localStorage.getItem("level") || "developer",
        ysb_type_activities_id: kegiatanId,
      };

      const response = await APISD.request({
        method: "GET",
        url: "/api/sub-activities",

        headers: {
          Authorization: token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        data: requestBody,
      });

      const rows = getArrayFromResponse(response?.data)
        .map(normalizeAspek)
        .filter((item) => {
          return (
            String(item?.ysb_type_activities_id || "") ===
            String(kegiatanId)
          );
        });

      setAspekData(rows);
    } catch (error) {
      console.log(
        "Gagal mengambil data aspek kegiatan:",
        error
      );

      setAspekData([]);

      showError(
        error?.response?.data?.message ||
          "Gagal mengambil data aspek kegiatan"
      );
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    setSearchAspek("");
    resetForm();
    setShowModal(false);

    if (selectedKegiatan?.id) {
      getAspekData();
    } else {
      setAspekData([]);
    }
  }, [selectedKegiatan?.id]);

  const filteredAspekData = useMemo(() => {
    const keyword = (searchAspek || "")
      .trim()
      .toLowerCase();

    const rows = !keyword
      ? aspekData
      : aspekData.filter((item) => {
          return (item?.name_sub_activities || "")
            .toString()
            .toLowerCase()
            .includes(keyword);
        });

    return rows
      .map((item, index) => ({ item, index }))
      .sort((a, b) => {
        const createdAtA = Date.parse(
          a.item?.created_at || ""
        );
        const createdAtB = Date.parse(
          b.item?.created_at || ""
        );

        if (
          Number.isFinite(createdAtA) &&
          Number.isFinite(createdAtB) &&
          createdAtA !== createdAtB
        ) {
          return createdAtA - createdAtB;
        }

        const idA = Number(a.item?.id);
        const idB = Number(b.item?.id);

        if (
          Number.isFinite(idA) &&
          Number.isFinite(idB) &&
          idA !== idB
        ) {
          return idA - idB;
        }

        // Pertahankan urutan dari API jika tanggal/ID tidak tersedia.
        return a.index - b.index;
      })
      .map(({ item }) => item);
  }, [aspekData, searchAspek]);

  const handleOpenAdd = () => {
    if (!selectedKegiatan?.id) {
      showError("Kegiatan belum dipilih");
      return;
    }

    resetForm();
    setShowModal(true);
  };

  const handleOpenEdit = (item) => {
    if (!item?.id) {
      showError("ID aspek tidak ditemukan");
      return;
    }

    setEditAspekId(item.id);

    setFormAspek({
      name_sub_activities:
        item?.name_sub_activities || "",
    });

    setShowModal(true);
  };

  const handleCloseModal = () => {
    if (isSubmitting) return;

    setShowModal(false);
    resetForm();
  };

  const handleChangeForm = (event) => {
    const { name, value } = event.target;

    setFormAspek((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    const kegiatanId = selectedKegiatan?.id || "";

    const namaAspek = (
      formAspek.name_sub_activities || ""
    ).trim();

    const userId = resolveUserId();
    const token = resolveToken();

    if (!kegiatanId) {
      showError("Kegiatan belum dipilih");
      return;
    }

    if (!namaAspek) {
      showError("Nama aspek wajib diisi");
      return;
    }

    if (!userId) {
      showError(
        "ID user tidak ditemukan. Silakan login ulang."
      );

      return;
    }

    /*
     * Payload sesuai API sub-activities:
     * - ysb_type_activities_id
     * - name_sub_activities
     * - user_id
     */
    const payload = {
      ysb_type_activities_id: kegiatanId,
      name_sub_activities: namaAspek,
      user_id: userId,
    };

    setIsSubmitting(true);

    try {
      let response;

      if (editAspekId) {
        response = await APISD.put(
          `/api/sub-activities/${editAspekId}`,
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
      } else {
        response = await APISD.post(
          "/api/sub-activities/store",
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
      }

      const isSuccess =
        response?.status >= 200 &&
        response?.status < 300;

      if (!isSuccess) {
        showError(
          response?.data?.message ||
            (editAspekId
              ? "Gagal mengubah aspek"
              : "Gagal menyimpan aspek")
        );

        return;
      }

      showSuccess(
        response?.data?.message ||
          (editAspekId
            ? "Aspek berhasil diubah"
            : "Aspek berhasil disimpan")
      );

      setShowModal(false);
      resetForm();

      await getAspekData();
    } catch (error) {
      console.log(
        editAspekId
          ? "Gagal mengubah aspek:"
          : "Gagal menyimpan aspek:",
        error
      );

      const validationMessage =
        error?.response?.data?.errors
          ? Object.values(
              error.response.data.errors
            )
              .flat()
              .join("\n")
          : "";

      showError(
        validationMessage ||
          error?.response?.data?.message ||
          error?.message ||
          (editAspekId
            ? "Gagal mengubah aspek"
            : "Gagal menyimpan aspek")
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = (item) => {
    if (!item?.id) {
      showError("ID aspek tidak ditemukan");
      return;
    }

    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: `Aspek "${
        item?.name_sub_activities || "-"
      }" akan dihapus`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const token = resolveToken();

      setDeletingAspekId(item.id);

      try {
        const response = await APISD.delete(
          `/api/sub-activities/${item.id}`,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const isSuccess =
          response?.status >= 200 &&
          response?.status < 300;

        if (!isSuccess) {
          showError(
            response?.data?.message ||
              "Gagal menghapus aspek"
          );

          return;
        }

        showSuccess(
          response?.data?.message ||
            "Aspek berhasil dihapus"
        );

        if (editAspekId === item.id) {
          setShowModal(false);
          resetForm();
        }

        await getAspekData();
      } catch (error) {
        console.log(
          "Gagal menghapus aspek:",
          error
        );

        showError(
          error?.response?.data?.message ||
            "Gagal menghapus aspek"
        );
      } finally {
        setDeletingAspekId(null);
      }
    });
  };

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
    }
  };

  return (
    <div className="body">
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header
            closeButton={!isSubmitting}
          >
            <Modal.Title>
              <h5 className="mb-0">
                {editAspekId
                  ? "Edit Aspek"
                  : "Buat Aspek"}
              </h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mt-3 label-group-form">
              <label className="label-name-form">
                Kegiatan
              </label>

              <input
                className="label-input-form"
                type="text"
                value={
                  selectedKegiatan?.name_activities ||
                  "-"
                }
                disabled
              />
            </div>

            <div className="mt-4 label-group-form">
              <label
                className="label-name-form"
                htmlFor="name_sub_activities"
              >
                Nama Aspek
              </label>

              <input
                id="name_sub_activities"
                className="label-input-form"
                autoFocus
                type="text"
                name="name_sub_activities"
                placeholder="Masukkan nama aspek"
                value={
                  formAspek.name_sub_activities
                }
                onChange={handleChangeForm}
                disabled={isSubmitting}
                maxLength={255}
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div
              className="d-flex"
              style={{
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <Button
                type="button"
                className="btn btn-light"
                onClick={handleCloseModal}
                disabled={isSubmitting}
                style={{
                  borderRadius: 10,
                  fontWeight: 600,
                  padding: "8px 14px",
                }}
              >
                Batal
              </Button>

              <Button
                className="btn-modal-create"
                type="submit"
                disabled={isSubmitting}
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  boxShadow:
                    "0 10px 24px rgba(108,99,255,0.18)",
                  fontWeight: 600,
                }}
              >
                {isSubmitting
                  ? editAspekId
                    ? "Mengubah..."
                    : "Menyimpan..."
                  : editAspekId
                    ? "Simpan Perubahan"
                    : "Simpan"}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon
                icon={faListCheck}
              />
            </span>

            <div>
              <h4 className="page-title-text mb-0">
                Aspek Kegiatan
              </h4>

              <small
                style={{
                  color: "#6b7280",
                  fontWeight: 500,
                }}
              >
                {selectedKegiatan?.name_activities ||
                  "-"}
              </small>
            </div>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              className="btn btn-light"
              onClick={handleBack}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                fontWeight: 600,
              }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
              />{" "}
              Kembali
            </button>
          </div>
        </div>
      </div>

      <div className="body-content">
        <div
          className="d-flex mt-4 mb-4"
          style={{
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            className="at-search"
            style={{
              flex: 1,
              minWidth: 240,
            }}
          >
            <input
              className="at-input"
              placeholder="Cari nama aspek"
              value={searchAspek}
              onChange={(event) =>
                setSearchAspek(
                  event.target.value
                )
              }
            />
          </div>

          <div className="ml-auto">
            <button
              type="button"
              onClick={handleOpenAdd}
              className="btn btn-create mr-2"
              disabled={!selectedKegiatan?.id}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                boxShadow:
                  "0 10px 24px rgba(108,99,255,0.18)",
                fontWeight: 600,
              }}
            >
              <FontAwesomeIcon
                icon={faPlus}
              />{" "}
              Buat Aspek
            </button>
          </div>
        </div>

        <Col xl="12" sm="12">
          <div className="mt-3 body-table">
            <table
              className="table table-hover custom-hover-table table-border-style"
              id="basic-datatable"
            >
              <thead>
                <tr>
                  <th>Nama Aspek</th>

                  <th
                    style={{
                      width: 220,
                      textAlign: "center",
                    }}
                  >
                    Aksi
                  </th>
                </tr>
              </thead>

              <tbody>
                {isFetching ? (
                  <tr>
                    <td
                      colSpan="2"
                      className="text-center"
                      style={{ padding: 18 }}
                    >
                      Mengambil data aspek...
                    </td>
                  </tr>
                ) : filteredAspekData.length >
                  0 ? (
                  filteredAspekData.map(
                    (row, index) => (
                      <tr
                        key={row?.id || index}
                      >
                        <td
                          style={{
                            lineHeight: "2",
                            fontWeight: 600,
                          }}
                        >
                          {row?.name_sub_activities ||
                            "-"}
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            lineHeight: "2",
                          }}
                        >
                          <div
                            className="d-flex justify-content-center"
                            style={{
                              gap: 8,
                              flexWrap: "wrap",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-warning"
                              onClick={() =>
                                handleOpenEdit(row)
                              }
                              style={{
                                borderRadius: 8,
                                color: "#fff",
                                fontWeight: 600,
                              }}
                            >
                              <FontAwesomeIcon
                                icon={
                                  faPenToSquare
                                }
                              />
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() =>
                                handleDelete(row)
                              }
                              disabled={
                                deletingAspekId ===
                                row.id
                              }
                              style={{
                                borderRadius: 8,
                                fontWeight: 600,
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTrash}
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="2"
                      className="text-center"
                      style={{ padding: 20 }}
                    >
                      Data aspek belum tersedia
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
      </div>
    </div>
  );
}
